import React, { useEffect } from 'react';
import { useNavigate,useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';

// API REQUEST 
import axios from 'axios';

import icon from "../../../assets/icons/ChatText.svg"
import prevIcon from "../../../assets/icons/coloredPrev.svg"

// React Redux 
import { useDispatch } from 'react-redux';
import { setCabRequests } from '../../../redux/userSlice';

// For Refresh handling
import useAuth from '../../../customHooks/useAuth';
import { baseUrl } from '../../../common/baseUrl';
import Remarks from '../../components/Remarks/Remarks';
import axiosInstance from '../../../axiosInstance/axiosInstance';
import { HOTEL_TIMEZONE } from "../../../common/hotelTime";
 

// Refer Cab Decesion.css CSS For this
export default function EditCabBooking() {


    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useDispatch();

    // Setting UP Cab Request Data
    const cabRequestData = location.state?.cabRequestData || {};
    const hotelId = location.state?.hotelId || "";
    const bookingId = location.state?.bookingId || "";

    // For Refresh Handle
    useAuth();


 
    // Check Is there is a booking Id and hotel Id otherwise redirect it to other page
    useEffect(()=>
    {
        const checkData = ()=>{
            // Check If It is Empty then Go To the Bookings
            if (bookingId === "" || hotelId === "" || Object.keys(cabRequestData).length === 0) {
                navigate("/bookings",{state : {activeRequests : "requests"}});
            } 
        }
        checkData();

    },[]);

    // Back Button
    const handleClick = () => {
        navigate("/bookings",{state : {activeRequests : "requests"}});
    }

    // Cancel Button
    const cancelButton = async() => {

        try{
            const formData = {accepted_by_guest : false};

            // console.log("Hotel Id : " + hotelId);
            // console.log("Booking Id : " + bookingId);
            // console.log("Cab Request Id : " + cabRequestData.id);
            // console.log("Booked Room ID : " + cabRequestData.booked_room_id);
        

            const response = await axiosInstance.patch(`/api/v1/users/${cabRequestData.user_id}/bookings/${bookingId}/booked-rooms/${cabRequestData.booked_room_id}/guest-requests/pre-checkin/cab-request/user-verdict?guest_request_id=${cabRequestData.guest_request_id}`,formData);

            // console.log("Response : ",response.data);

            toast.success("PreCheckIn Cab Request Cancelled Successfully");
            navigate("/bookings",{state : {activeRequests : "requests"}});


            // try{
            //     const response2 = await axiosInstance.get(`/api/v1/users/${cabRequestData.user_id}/requests`);

            //     console.log("Respose Data in Cab Decision : ",response2.data.data);
        
            //     dispatch(setCabRequests(response2.data.data));

            
        
            // }catch(error){
            //     console.log(error);
            // }

        }
        catch(error){
            toast.error(error?.response?.data?.message || "Some Error Occured");
            console.log(error);
        }
    }

    // Edit Button
    const editButton = ()=>{

        navigate("/updateCabBooking",{state : {
            pick_up_location : cabRequestData.pick_up_location,
            time : cabRequestData.time_of_arrival,
            people : cabRequestData.number_of_people,
            bookingId : bookingId,
            cabRequestData : cabRequestData
        }})

    }


   

    // Function to format the date (e.g., "07 Oct")
    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const day = date.getDate();
        const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sept", "Oct", "Nov", "Dec"];
        const month = monthNames[date.getMonth()];
        return `${day} ${month}`;
    };

    // Function to extract the year (e.g., "2024")
    const formatYear = (dateString) => {
        const date = new Date(dateString);
        const year = date.getFullYear(); // Extracts the full year (e.g., "2024")
        return year;
    };

    // Function to format the time (e.g., "22:11")
    const formatTimePeriod = (dateString) => {
        const date = new Date(dateString);
        return date.toLocaleTimeString([], {
            timeZone: HOTEL_TIMEZONE, hour: '2-digit', minute: '2-digit' });
    };
        
    
    return (
    <div className='cab-decesion'>

    {/* Cab Header */}
    <div className='cab-decesion-header'>
        <div className="cab-decesion-content">
            <div className='prev-icon' onClick={handleClick}>
                <img src={prevIcon} alt="" />
            </div>
            <div className='cab-decesion-data'>
                <div className='cab-decesion-data-header'>
                    <h6>
                    Book your cab to your stay
                    </h6>
                    <p>
                    Reserve a comfortable and reliable transportation option for your convenient journey.
                    </p>
                </div>
            </div>
        </div>
    </div>
    
    {/* Remarks */}
    {cabRequestData.remarks && 
        <div>
            <Remarks para={cabRequestData.remarks}/>
        </div>
    }

    {/* Cab Pickup Message */}
        <div className="cab-pickup-msg"> 


            {/* Pickup Location */}
            <div className="pickup-location">
                <div className="msg-header">
                    <h4>Pick Up Location</h4>
                </div>
                <div className="pickup-msg">
                    <h6>{cabRequestData.pick_up_location}</h6>
                </div>
            </div>

            {/* Number Of People */}
            <div className="pickup-people">
                <div className="msg-header">
                    <h4>Number of People</h4>
                </div>
                <div className="pickup-people-msg" >
                    <h6> 
                        {cabRequestData.number_of_people} people
                    </h6>
                </div>
            </div>
            
            {/* Cab Time Message */}
            <div className="cab-time">
                <div className="msg-header">
                    <h4>When do you want cab ?</h4>
                </div>
                <div className="cab-time-msg">
                
                <h6>
                    {/* {formatDateToISO(cabRequestData.time_of_arrival)  || ""} */}
                    {formatDate(cabRequestData.time_of_arrival) || ""}-
                    {formatYear(cabRequestData.time_of_arrival) || ""}-
                    {formatTimePeriod(cabRequestData.time_of_arrival) || ""}
                </h6>
                </div>
            </div>

            {/* Fee Requested */}
            {cabRequestData.status !== "Pending_Hotel" && cabRequestData.price!=0 && (
                <div className="cab-fee">
                    <div className="msg-header">
                        <h4>Fee Requested By Hotel</h4>
                    </div>
                    <div className="cab-fee-msg">
                        <h6>
                            ₹ {cabRequestData.price}
                        </h6>
                    </div>
                </div>
            )}
            
            {
                cabRequestData?.price===0 && (
                    <div className="cab-fee">
                    <div className="msg-header">
                        <h4>Fee Requested By Hotel</h4>
                    </div>
                    <div className="cab-fee-msg">
                        <h6>
                            ₹ {cabRequestData.price}
                        </h6>
                    </div>
                </div>

                )
            }


            {/* Driver Assigned */}
            {cabRequestData.status !== "Pending_Hotel" && cabRequestData.driver_name && (
                <div className="cab-driver">
                    <div className="msg-header">
                        <h4>Driver Assigned</h4>
                    </div>
                    <div className="cab-driver-msg">
                        <h6>
                            {cabRequestData.driver_name}
                        </h6>
                    </div>
                </div>
            )}
    
        </div>

        {/* Hotel Remark */}
        {cabRequestData.status !== "Pending_Hotel" && cabRequestData.driver_contact && cabRequestData.vehicle_number && (
        <div className="hotel-remark">
            <div className="icon-hotel">
                <img src={icon} alt='' />
            </div>
            <div className="hotel-msg">
                <div className="hotel-msg-header">
                    <h5>
                        Driver Details : 
                    </h5>
                    <p>
                        Driver Phone Number : {cabRequestData.driver_contact}
                        <br/>
                        Veichle Number : {cabRequestData.vehicle_number} 
                    </p>
                </div>
            </div>
        </div>
        )}


        {/* <div className="edit-btn">
            <button onClick={editButton}>Edit Request</button>
        </div> */}

        {(cabRequestData.status === "Completed_Hotel" || 
        cabRequestData.status === "Closed_Hotel" || 
        cabRequestData.status === "Declined_Guest" || 
        cabRequestData.status === "Closed_Guest" || cabRequestData.status === "Declined_Hotel" ) ? 
            <div></div> : (
            // Fee Buttons
            <div className="fee-btns">
                <div className="cancel-btn">
                    <button onClick={cancelButton}>Cancel Request</button>
                </div>
                {cabRequestData.status==="InProgress_Hotel" || cabRequestData.status==="Scheduled_Hotel" ? 
                
                    <div></div> 
                
                :
                    <div className="edit-btn"></div>
                }
            </div>
            )
        }



    </div>
  )
}
